import { Component, Input } from '@angular/core';
import { NgSwitch } from '@angular/common';

@Component({
  selector: 'app-cart-discount',
  templateUrl: './cart-discount.component.html',
  styleUrls: ['./cart-discount.component.scss']
})
export class CartDiscountComponent {
  @Input() distributor;
  constructor() {}
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/shopping-cart/cart-discount/cart-discount.component.ts